'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimestamp = exports.logger = undefined;

var _logger = require('./logger');

exports.logger = _logger.logger;
exports.getTimestamp = _logger.getTimestamp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-beacon/extensions/logger/index.js
// module id = 678
// module chunks = 0 1